import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, Validators, AbstractControl, FormControl, NgModel, ValidatorFn, ValidationErrors } from '@angular/forms';
import { PasswordValidationService } from '../../shared/services/password-validation.service';

@Component({
    selector: 're-user-activate-with-password',
    templateUrl: './user-activate-with-password.component.html',
    styleUrls: ['./user-activate-with-password.component.scss'],
    standalone: false
})
export class UserActivateWithPasswordComponent implements OnInit, AfterViewInit {


  constructor(public modal: NgbActiveModal, private passwordValidationSvc: PasswordValidationService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.confirmPasswordControl.control.setValidators([Validators.required, (control) => this.comparePasswordValidator(control)]);
    this.passwordControl.control.setValidators([Validators.required, (control) => this.passwordComplexityValidator(control)]);
  }

  comparePasswordValidator(control: AbstractControl): ValidationErrors | null {
    if (this.password != control.value)
      return { compare: true };

    return null; 
}
  passwordComplexityValidator(control: AbstractControl): ValidationErrors | null {
    var valid = this.passwordValidationSvc.validatePassword(control.value, this.userName, null, this.firstName, this.lastName, true, true, true).isValid();
    if (valid)
      return null;

    return { complex : valid};
  }

  passwordChanged() {
    //lets trigger the validation of the confirmControl in case that one was typed first.
    this.confirmPasswordControl.control.updateValueAndValidity();
  }
  password: string;
  confirmPassword: string;

  firstName: string;
  lastName: string;
  userName: string;
  userPassword : string;
  deactivationDate: any;

  close() {
    this.modal.close(null);
  }

  activate() {
    this.modal.close(this.password);
  }

  @ViewChild("confirmPasswordControl")
  confirmPasswordControl: NgModel;

  @ViewChild("passwordControl")
  passwordControl: NgModel;

  // It validates the Username, Firstname, Lastname when Admin paste the password
  onPaste(event: ClipboardEvent) {
    this.userPassword = event.clipboardData.getData('text');
  }

}
